export enum Localizations {
    en = 'en',
    de = 'de',
}
